import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { combineReducers } from "redux";

import AlertReducer from "./Alerts/reducer";
import AuthReducer from "./Auth/reducer";
import UserReducer from "./Users/reducer";
import RoleReducer from "./Roles/reducer";
import ItemReducer from "./Items/reducer";
import usePreventReducer from "./usePrevent/reducer";
import CareHomeGroupsReducer from "./CareHomeGroups/reducer";
import HomesReducer from "./Homes/reducer";
import EnquiriesReducer from "./Enquiries/reducer";
import NewsReducer from "./News/reducer";
import FaqsReducer from "./Faqs/reducer";
import HomeGroupAdminReducer from "./HomeGroupsAdmin/reducer";
import PagesReducer from "./Pages/reducer";
import SlickCareProfilesReducer from "./SlickCareProfiles/reducer";
import HomeGroupStaffReducer from "./HomeGroupsStaff/reducer";
import BlogsReducer from "./Blogs/reducer";
import ResidenceReducer from "./Residence/reducer";
import WebsiteReducer from "./Website/reducer";
import TOCReducer from "./TypesOfCare/reducer";
import RoomReducer from "./Rooms/reducer";
import SettingsReducer from "./EmailSettings/reducer";
import LocationBlogsReducer from "./LocationBlogs/reducer";
import ReviewsReducer from "./Reviews/reducer";
import ContactReducer from "./Contacts/reducer";
import ReviewSettingsReducer from "./ReviewSetting/reducer";
import PackageReducer from "./Package/reducer";
import HistoryReducer from "./History/reducer";
import FilterReducer from "./Filter/reducer";
import PrintReducer from "./Print/reducer";
import NetworkReducer from "./Networking/reducer";
import TaskReducer from "./Task/reducer";
import SurveyReducer from "./Survey/reducer";
import BundlesReducer from "./Bundles/reducer";
//
import RosterReducer from "./Roster/reducer";
import RosterRoleReducer from "./EmployeeRole/reducer";
import EmployeeReducer from "./Employee/reducer";
import LeaveReducer from "./EmployeeLeave/reducer";
import ShiftReducer from "./EmployeeShifts/reducer";
import RotaReducer from "./EmployeeRota/reducer";
import BudgetReducer from "./Budget/reducer";
import SheetReducer from "./Timesheet/reducer";
import WebsiteEnquiriesReducer from "./WebsiteEnquiries/reducer";
import HubBlogReducer from "./HubBlog/reducer";
import DiscrepancyReducer from "./Discrepancy/reducer";
import AvailabilityReducer from "./Availability/reducer";
import TerminalReducer from "./Terminals/reducer";
import NotificationReducer from "./Notification/reducer";
import TeamReducer from "./Teams/reducer";
import FeedReducer from "./Feed/reducer";
import FeedActionReducer from "./FeedAction/reducer";
import CommentReducer from "./FeedComments/reducer";

const authPersistConfig = {
  key: "AuthReducer",
  storage: storage,
  blacklist: [],
};

const profilePersistConfig = {
  key: "SlickCareProfilesReducer",
  storage: storage,
  blacklist: [],
};

const rootReducer = combineReducers({
  AuthReducer: persistReducer(authPersistConfig, AuthReducer),
  UserReducer,
  RoleReducer,
  ItemReducer,
  usePreventReducer,
  AlertReducer,
  CareHomeGroupsReducer,
  HomesReducer,
  EnquiriesReducer,
  NewsReducer,
  FaqsReducer,
  HomeGroupAdminReducer,
  PagesReducer,
  SlickCareProfilesReducer: persistReducer(
    profilePersistConfig,
    SlickCareProfilesReducer
  ),
  HomeGroupStaffReducer,
  BlogsReducer,
  ResidenceReducer,
  WebsiteReducer,
  TOCReducer,
  RoomReducer,
  SettingsReducer,
  LocationBlogsReducer,
  ReviewsReducer,
  ContactReducer,
  ReviewSettingsReducer,
  PackageReducer,
  HistoryReducer,
  FilterReducer,
  PrintReducer,
  NetworkReducer,
  TaskReducer,
  SurveyReducer,
  BundlesReducer,
  //
  RosterReducer,
  EmployeeReducer,
  RosterRoleReducer,
  LeaveReducer,
  ShiftReducer,
  RotaReducer,
  BudgetReducer,
  SheetReducer,
  WebsiteEnquiriesReducer,
  HubBlogReducer,
  DiscrepancyReducer,
  AvailabilityReducer,
  TerminalReducer,
  NotificationReducer,
  TeamReducer,
  FeedReducer,
  FeedActionReducer,
  CommentReducer,
});

export default rootReducer;
